import {
    login,
    loginStudent,
    forgot,
    signup,
    logout,
    getUser,
    resetPassword,
    confirmCode,
    newPasswordForgot, getStudent, autoLoginStudentB2B
} from "./../api.js";
import Cookies from "js-cookie";

export const state = {
    token: Cookies.get("rsr-user-token"),
    isSsoLogin: Cookies.get("redirect_from_mk_b2b") === "1",
    user: {},
    permissions: [],
    loginRes: {},
    forgotPasswordResponse: {},
    signupRes: {},
    logoutRes: {},
    newPassword: {},
    listUserResponse: {},
    confirmCodeRes : {},
    newPasswordForgotRes :{},
    logo: {}
};

export const getters = {
    confirmCodeRes: state =>
        state.confirmCodeRes ? state.confirmCodeRes : {},
    newPasswordForgotRes: state =>
        state.newPasswordForgotRes ? state.newPasswordForgotRes : {},
    listUserResponse: state =>
    state.listUserResponse ? state.listUserResponse.data : [],
    token: state => state.token,
    loginRes: state => state.loginRes,
    forgotPasswordResponse: state => state.forgotPasswordResponse,
    signupRes: state =>
         state.signupRes ? state.signupRes : {},
    isLogin: state => !!state.token,
    isSsoLogin: state => !!state.token && state.isSsoLogin,
    newPassword: state => state.newPassword,
    user: state => state.user,
    permissions: state => state.permissions,
    editTeacherRes: state => state.editTeacherRes,
    logo: state => state.logo
};

export const mutations = {
    getList(state, data) {
        state.listUserResponse = data.data;
      },
    login(state, data) {
        if (!data.error) {
            state.loginRes = data;
            state.token = data.data.access_token;
            state.isSsoLogin = !!data.isSsoLogin;
            if (state.isSsoLogin) {
                Cookies.set("redirect_from_mk_b2b", 1);
            } else {
                Cookies.remove("redirect_from_mk_b2b");
            }
            Cookies.set("rsr-user-token", data.data.access_token, {expires: 2 });
            Cookies.set("student-permissions", data.data.permissions ? data.data.permissions : "", {expires: 2 });
        } else {
            state.loginRes = data.error.response.data;
        }
    },
    forgot(state, data) {
        if(data.status != undefined) {
            state.forgotPasswordResponse = data.status;
        }
        else {
            state.forgotPasswordResponse = data.error.response.data.code;
        }
    },

    signupMuta(state, data) {
        if (!data.error) {
            state.signupRes = data;
        } else {
            state.signupRes = data.error.response.data;
        }
        // state.signupRes = data.error.response.data;
    },
    logout(state, data) {
        if (!data.error) {
            state.logoutRes = data;
            Cookies.remove("rsr-user-token");
            state.token = null;
            state.isSsoLogin = false;
            Cookies.remove("redirect_from_mk_b2b");
        }
    },
    // editTeacher(state, data) {
    //     if (!data.error) {
    //         state.editTeacherRes = data;
    //         // Cookies.remove("rsr-user-token");
    //         // state.token = null;
    //     }
    // },
    clearToken(state) {
        state.token = null;
        state.isSsoLogin = false;
        Cookies.remove("redirect_from_mk_b2b");
        Cookies.remove("rsr-user-token");
    },
    GET_USER_SUCCESS(state, data) {
        if (!data.error) {
            state.user = data.data.user;
            state.permissions = data.data.permissions;
            state.logo = data.data.logo

            console.log(data)
            console.log("---------------")
            console.log(data.data)
            console.log("---------------")
            console.log(data.data.user)
            console.log("---------------")
            console.log(data.data.permissions)
            console.log("---------------")
            console.log(data.data.logo)
        }
    },
    resetPassword(state, data) {
        if (!data.error) {
            state.newPassword = data;
        }
        else {
            state.newPassword = data.error.response.data;
        }
    },
    confirmCodeMuta(state, data) {
        if(data.status != undefined) {
            state.confirmCodeRes = data.status;
        }
        else {
            state.confirmCodeRes = data.error.response.data.code;
        }
    },
    newPasswordForgot(state, data) {
        if (!data.error) {
            state.newPasswordForgotRes = data;
        } else {
            state.newPasswordForgotRes = data.error.response.data.error.code;
        }
    },
};

export const actions = {
    async login({commit}, params) {
        let data = await login(params);
        commit("login", data);
    },
    async loginStudent({commit}, params) {
        let data = await loginStudent(params);
        commit("login", {...data, isSsoLogin: Number(params.auto) === 1});
    },
    async autoLoginStudentB2B({commit}, params) {
        let data = await autoLoginStudentB2B(params);
        commit("login", {...data, isSsoLogin: true});
    },
    async forgot({commit}, params) {
        let data = await forgot(params);
        commit("forgot", data);
    },
    async signup({commit}, params) {
        let data = await signup(params);
        commit("signupMuta", data);
    },

    async logout({commit}, params) {
        let data = await logout(params);
        commit("logout", data);
    },
    clearToken({commit}) {
        commit("clearToken");
    },
    async getUser({commit}) {
        let data = await getUser();
        commit("GET_USER_SUCCESS", data);
    },
    async getStudent({commit}) {
        let data = await getStudent();
        commit("GET_USER_SUCCESS", data);
    },
    async resetPassword({commit}, paramsResetPassword) {
        let data = await resetPassword(paramsResetPassword);
        commit("resetPassword", data);
    },
    async confirmCode({commit}, paramsResetPassword) {
        let data = await confirmCode(paramsResetPassword);
        commit("confirmCodeMuta", data);

    },
    async newPasswordForgot( { commit }, paramsResetPassword){
        let data = await newPasswordForgot(paramsResetPassword);
        commit("newPasswordForgot", data);
    }
};

